export default __webpack_public_path__ + "static/media/startButtonHover.410845b5.svg";